/*
 *
 * TutorialTour constants
 *
 */

enum ActionTypes {
  DISPLAY_TUTORIAL = 'app/TutorialTour/DISPLAY_TUTORIAL',
  GO_TO_STEP_TUTORIAL = 'app/TutorialTour/NEXT_STEP_TUTORIAL',
}

export default ActionTypes;
